import React from "react";
import { Button, Grid } from "@mui/material";
import { useTheme } from "@emotion/react";
import { getSections } from "./bookmarks";


const TimelineBar = ({bookmark, tabValue, handleTimelineClick, handleTimelineDoubleClick}) => {
    const theme = useTheme();
    const sections = getSections(bookmark)
    return (
        <Grid container
            spacing={0}
            rows={1}
            columns={sections.length > 0 ? sections[sections.length - 1].time : 0}
            sx={{width: "100%"}}
        >
        {sections.slice(0, -1).map((start, ind) => (
            <Grid item xs={sections[ind+1].time-start.time} key={ind}>
                <Button
                fullWidth
                onClick={(e) => handleTimelineClick(ind)}
                onDoubleClick={(e) => handleTimelineDoubleClick(ind)}
                style={{
                minWidth: '4px',
                backgroundColor: ( start.color === "" ? (ind % 2 === 0 ? theme.palette.primary.dark : theme.palette.primary.light) : start.color),
                border: ind == tabValue ? '2px solid #000000' : 'none',
                textTransform: 'capitalize'
                }}
                >
                </Button>
            </Grid>
        ))}
        </Grid>
    );
}

export default TimelineBar;